.itemHolder {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 0.25em;
  justify-content: space-between;
  margin: 0 0.5em;
  padding-bottom: 0.5em;
  position: relative;
}
.itemPropertyHolder {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 0.5em;
  justify-content: center;
  width: 100%;
}
.itemPropertyLabel {
  font-size: 0.8rem;
  font-weight: bold;
  text-align: right;
  width: 6em;
}
.itemPropertyInput {
  border-radius: 2px;
  border: 1px solid var(--bs-gray-300);
  outline: none;
  padding: 2px;
}
.itemTypeSelect {
  border-radius: 2px;
  border: 1px solid var(--bs-gray-300);
  margin-left: 0.5rem;
  margin: 2px;
  outline: none;
  padding: 2px;
}
.itemTypeSelect:focus {
  box-shadow: none;
  outline: 1px solid var(--bs-primary);
}
.itemTypeOption {
  text-align: right;
}
.itemDeleteButton {
  background-color: transparent;
  border: none;
  color: var(--bs-danger);
  cursor: pointer;
  margin: 2px;
  padding: 2px;
}

.itemsHolder {
  position: relative;
  width: 100%;
}
.removeButtonHolder {
  position: absolute;
  right: 0;
  top: 0;
}
